<template>
  <div>
    <v-container fluid>
    <v-layout row wrap>
      <h2>Current Artist</h2>
      <v-flex xs12 px-3>
          {{artwork.artist.full_name}}
          {{this.f_artist}}
      </v-flex>
      
      <!-- <v-flex xs12>
        <v-subheader v-text="'Select artists who belong to this multi artist'"></v-subheader>
      </v-flex> -->
      <v-flex xs12 px-3>
        <v-select
          :items="artists"
          v-model="multi_artists"
          label="Select artists who belong to this multi artist"
          item-text="name"
          item-value="id"
          autocomplete
          chips
          deletable-chips
          multiple
        ></v-select>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12>
        <v-data-iterator :items="multi_artists" item-key="id" item-value="id" row wrap hide-actions>
          <v-card slot="item" slot-scope="props" class="elevation-2 mb-3 mx-3">
            <!-- {{this.$store.state.artists}} -->
            <v-card-title class="title">{{ (ids2o ([props.item]))[0].name }}</v-card-title>
            <v-card-text v-if="ids2o ([props.item])[0].artworks">{{ ids2o ([props.item])[0].artworks.length }} artwork.</v-card-text>
          </v-card>
        </v-data-iterator>
      </v-flex>
    </v-layout>
  </v-container>
  </div>
</template>

<script>
  // function ids2o (array) {
  //   var objs = Object.assign([], this.$store.state.artists)
  //   var out = objs.filter(a => {
  //     // console.log(array.includes(a.id))
  //     return (array.includes(a.id))
  //   })
  //   return out
  // }

  export default {
    props: ['field','artist','artwork'],
    data: function () {
      return {
        multi_artists: [],
        artists: this.$store.state.artists,
        f_artist: this.artist,

      }
    },
    methods: {
      ids2o (array) {
        // console.log(array)
        if (array.length > 0) {
          var objs = Object.assign([], this.$store.state.artists)
          var out = objs.filter(a => {
            // console.log(array.includes(a.id))
            return (array.includes(a.id))
          })
        // console.log(out)
          return out
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/artworks/MultiArtist.vue